module.exports = __webpack_public_path__ + "img/check-check.32a78261.svg";